/**
 * A shape standing in for something still loading: the hairline grey it
 * will sit on, with a slow sweep of light across it — so a first load reads
 * as on its way, never as missing.
 *
 * Shape and size come from the caller (`h-4 w-32 rounded-pill`); the sweep
 * stops under reduced motion, leaving the shape.
 */
export function Skeleton({ className = '' }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`relative overflow-hidden bg-hairline/70 ${className}`}
    >
      <div className="pointer-events-none absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-surface/70 to-transparent motion-reduce:hidden" />
    </div>
  );
}
